import { emojiPickerIcons } from './emoji-picker-icons';

const totalEmojiGroups = 8;
let current_emojiPickerInputID = '';

export default function initEmojiPicker($containerWrapper, callbackValue) {
    for (var i = 1, l = totalEmojiGroups; i <= l; i++) {
        $containerWrapper.append(renderEmojiPickerList(i));
    }

    initEvents(callbackValue);
}

function initEvents(callbackValue) {
    $(document).on('click, mousedown', function (event) {
        const $container = $('.emoji-picker-container');
        const $emojiPicker = $('.emoji-picker');

        if ($(event.target).hasClass('emoji-picker') && !$(event.target).hasClass('disabled')) {
            const $emojiPickerwrapper = $('.emoji-picker-wrapper');

            if (!$container.is(':visible')) {
                const containerWidth = $container.outerWidth();
                const picker = $(event.target);
                const pickerHeight = picker.outerWidth();
                const pickerWidth = picker.outerHeight();
                const pickerTop = picker.offset().top;
                const pickerLeft = picker.offset().left;

                current_emojiPickerInputID = picker.context.dataset.for;

                $container.css('top', pickerTop + pickerHeight + 1);
                $container.css('left', pickerLeft + pickerWidth - containerWidth + 6);

                $emojiPicker.removeClass('is-active');
                picker.addClass('is-active');

                $container.addClass('active');
                $emojiPickerwrapper.scrollTop('0');
            } else {
                $container.removeClass('active');
            }
        } else if ($(event.target).closest($container).length === 0 && $container.is(":visible")) {
            $container.removeClass('active');
            $('.emoji-picker').removeClass('is-active');
        }
    });

    $(".emoji-block button").click(function(ev){
        const emoji = $(this).text();
        const $emojiId = $('#' + current_emojiPickerInputID);
        const inputvalue = $emojiId.val();
        let inputlength = inputvalue.length;
        let isPreview = false;
        if(current_emojiPickerInputID.indexOf('txtPreview') > -1) {
            isPreview = true;
        }

        if (inputvalue) {
            const surrogatePairs = inputvalue.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
            inputlength = inputlength - surrogatePairs.length;
        }
        let maxlength = $emojiId.attr('maxlength');

        if (maxlength) {
            maxlength = parseInt(maxlength);
        }
        if ( typeof maxlength != 'undefined' ) {
            if (inputlength < maxlength) {
                $emojiId.insertAtCaret(emoji);
                $emojiId.change();
                callbackValue($emojiId.val(), isPreview);
            }
        } else {
            $emojiId.insertAtCaret(emoji);
            $emojiId.change();
            callbackValue($emojiId.val());
        }
    });

    $('.emoji-picker-group-nav').click(function(ev) {
        ev.preventDefault();

        const $emojiPickerwrapper = $('.emoji-picker-wrapper');
        let group = $(this).data('value');

        $emojiPickerwrapper.scrollTop('0');

        let element = $(".emoji-group-name[data-group='" + group +"']");
        let elementTop = element.position().top;

        if (group != '1') {
            $emojiPickerwrapper.scrollTop(elementTop - 46);
        }
    });

    const $emojiPickerWrapperId = document.getElementById('emojiPickerWrapper');
    const emojiPickerWrapperScroll = debounce(function() {
        emojiPickerWrapperNavUpdate();
    }, 10);

    if($emojiPickerWrapperId) {
        $emojiPickerWrapperId.addEventListener('scroll', emojiPickerWrapperScroll);
    }
}

function emojiPickerWrapperNavUpdate() {
    for (let i = totalEmojiGroups, l = 0; i > l; i--) {
        let element = $('.emoji-group-name[data-group="' + i + '"]');
        if (element) {
            var paddingTop = 46;
            var top = element.position().top - paddingTop;
            if ( top <= 0 ) {
                $('.emoji-picker-group-nav').removeClass('current-group');
                $('.emoji-picker-group-nav[data-value="' + i + '"]').addClass('current-group');
                break;
            }
        }
    }
}

function renderEmojiPickerList(group) {
    const groupname = emojiPickerIcons['emoji_group_name_' + group];
    const grouplist = emojiPickerIcons['emoji_group_list_' + group];
    let html = '';

    html += '<div class="emoji-group-name" data-group="' + group + '">' + groupname + '</div>';
    html += '<ul class="emoji-list">';

    for (let i = 0, l = grouplist.length; i < l; i++) {
        html += '<li class="emoji-block">';
        html += '<button type="button" title="' + grouplist[i][1] + '">' + grouplist[i][0] + '</button>';
        html += '</li>';
    }

    html += '<ul>';

    return html;
}

function debounce(func, wait, immediate) {
    let timeout;
    return () => {
        let context = this,
            args = arguments,
            later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            },
            callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

jQuery.fn.extend({
    insertAtCaret: function(myValue) {
        return this.each(function(i) {
            //For browsers like Internet Explorer
            if (document.selection) {
                var sel = document.selection.createRange();

                this.focus();
                sel.text = myValue;
                this.focus();
            }
            //For browsers like Firefox and Webkit based
            else if (this.selectionStart || this.selectionStart == '0') {
                const startPos = this.selectionStart;
                const endPos = this.selectionEnd;
                const scrollTop = this.scrollTop;

                this.value = this.value.substring(0, startPos) + myValue + this.value.substring(endPos, this.value.length);
                this.focus();
                this.selectionStart = startPos + myValue.length;
                this.selectionEnd = startPos + myValue.length;
                this.scrollTop = scrollTop;
            } else {
                this.value += myValue;
                this.focus();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./app/utils/emoji-picker.js